/**
 * Authentication Hook
 *
 * Provides authentication state and actions.
 * Wraps Zustand store for convenient access.
 */

import { useAuthStore } from '@/stores/authStore'

/**
 * Hook for accessing authentication state and actions
 */
export function useAuth() {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    refreshUser,
    clearError,
  } = useAuthStore()

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    refreshUser,
    clearError,

    // Convenience methods
    isAdmin: user?.role === 'admin',
    isManager: user?.role === 'manager' || user?.role === 'admin',
    isSeller: user?.role === 'seller',
  }
}

/**
 * Hook to require authentication
 *
 * Returns true if user is authenticated, throws if not.
 */
export function useRequireAuth() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return { isLoading: true }
  }

  if (!isAuthenticated) {
    throw new Error('Authentication required')
  }

  return { isLoading: false }
}
